<template>
    <div
        class="sub-page-wrap"
    >
        <div
            class="sub-page"
        >
            <!-- 이미지/링크는 그대로 쓰고 싶으면 그대로 사용 가능 -->
            <section class="c-section d-flex justify-center pt-0">
                <a
                    v-if="detailLinkUrl"
                    :href="detailLinkUrl"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="badge-link"
                >
                    
                </a>

                <div class="c-contanier text-center">
                    <!-- 폼 (로직은 mixin의 name/email/showConfirm/submit 그대로 사용) -->
                    <div class="form">
                        <v-form ref="form">
                            <div class="d-flex flex-column align-center">
                                <div
                                    style="width: 440px;"
                                    class="text-left mb-2"
                                >
                                    <p class="contact_title mb-2">
                                        <strong style="font-size: 32px;">이름</strong>
                                        <span
                                            class="text-red1 ml-1"
                                            style="font-size: 32px; font-weight: bold;"
                                        >*</span>
                                    </p>
                                    <v-text-field
                                        v-model="name"
                                        :rules="[v => !!v || $t('trialBadgeCampaign.errors.nameRequired')]"
                                        outlined
                                        :dense="$vuetify.breakpoint.smAndDown"
                                        color="blue1"
                                    />
                                </div>
  
                                <div
                                    style="width: 440px;"
                                    class="mb-2 text-left"
                                >
                                    <p class="contact_title mb-2">
                                        <strong style="font-size: 32px;">이메일</strong>
                                        <span
                                            class="text-red1 ml-1"
                                            style="font-size: 32px; font-weight: bold;"
                                        >*</span>
                                    </p>
                                    <v-text-field
                                        v-model="email"
                                        :rules="[
                                            v => !!v || $t('trialBadgeCampaign.errors.emailRequired'),
                                            v => /.+@.+\..+/.test(v) || $t('trialBadgeCampaign.errors.emailInvalid')
                                        ]"
                                        outlined
                                        :dense="$vuetify.breakpoint.smAndDown"
                                        color="blue1"
                                        type="email"
                                    />
                                </div>
  
                                <v-btn
                                    class="mt-5"
                                    color="#582915"
                                    depressed
                                    dark
                                    style="height: 82px !important; min-width: 240px !important; font-size: 36px !important;"
                                    :ripple="false"
                                    @click="showConfirm"
                                >
                                    발행하기
                                </v-btn>

                                <v-btn
                                    v-if="false"
                                    class="mt-2"
                                    color="#582915"
                                    depressed
                                    dark
                                    style="height: 51px !important; min-width: 148px !important; font-size: 21px !important;"
                                    @pointerup.prevent.stop="testAction"
                                    @touchstart="dbg('touchstart')"
                                    @mouseover="dbg('mouseover')"
                                    @click="dbg('click')"
                                >
                                    test
                                </v-btn>


                                <div
                                    v-if="false"
                                    style="
                                        position: fixed;
                                        bottom: 20px;
                                        left: 20px;
                                        background: rgba(0,0,0,0.75);
                                        color: #0f0;
                                        padding: 10px;
                                        font-size: 14px;
                                        z-index: 9999;
                                        border-radius: 6px;
                                        min-width: 220px;
                                        width: 300px;
                                        height: 500px;
                                        overflow-y: auto;
                                    "
                                >
                                    <div
                                        v-for="(l,i) in dbgLogs"
                                        :key="i"
                                    >
                                        {{ l }}
                                    </div>
                                </div>
                            </div>
                        </v-form>
                    </div>
                </div>
            </section>
  
            <!-- Confirm Dialog (DefaultCampaign과 동일 로직/상태 사용) -->
            <v-dialog
                v-model="confirmOpen"
                width="550"
                transition="none"
                persistent
            >
                <v-card class="pa-0 rounded-lg">
                    <div
                        class="le-heading6 pa-9 pb-5"
                        style="font-size: 32px;"
                    >
                        {{ $t('trialBadgeCampaign.dialogConfirm.title') }}
                    </div>
  
                    <div
                        v-if="loading"
                        class="center-absolute"
                    >
                        <v-progress-circular
                            indeterminate
                            color="orange1"
                            size="60"
                            width="10"
                        />
                    </div>
  
                    <div
                        class="le-text-body2 px-9 mb-5"
                        style="min-height:88px; font-size: 24px;"
                    >
                        <p class="mb-5">
                            {{ $t('trialBadgeCampaign.dialogConfirm.intro') }}
                        </p>
                        <strong>{{ name }}</strong><br />
                        <strong>{{ email }}</strong><br />
                        <p class="mt-5">
                            {{ $t('trialBadgeCampaign.dialogConfirm.question') }}
                        </p>
                    </div>
  
                    <div class="pa-9 d-flex justify-end gap-5">
                        <v-btn
                            color="#582915"
                            outlined
                            depressed
                            style="height: 60px !important; min-width: 120px !important; font-size: 28px !important;"
                            :ripple="false"
                            @touchstart="dbgEvent('NO touchstart', $event)"
                            @touchend="dbgEvent('NO touchend', $event)"
                            @pointerdown="dbgEvent('NO pointerdown', $event)"
                            @pointerup="dbgEvent('NO pointerup', $event)"
                            @mousedown="dbgEvent('NO mousedown', $event)"
                            @mouseup="dbgEvent('NO mouseup', $event)"
                            @click="onNoClick"
                        >
                            {{ $t('trialBadgeCampaign.dialogConfirm.btnNo') }}
                        </v-btn>
                        <v-btn
                            color="#582915"
                            depressed
                            :class="{disabled:loading}"
                            dark
                            style="height: 60px !important; min-width: 120px !important; font-size: 28px !important;"
                            :ripple="false"
                            @click="submit"
                        >
                            {{ $t('trialBadgeCampaign.dialogConfirm.btnYes') }}
                        </v-btn>
                    </div>
                </v-card>
            </v-dialog>
  
            <!-- Done Dialog -->
            <v-dialog
                v-model="doneOpen"
                width="550"
                transition="none"
                persistent
            >
                <v-card class="pa-0 rounded-lg">
                    <div
                        class="le-heading6 pa-9 pb-5"
                        style="font-size: 32px;"
                    >
                        {{ $t('trialBadgeCampaign.dialogDone.title') }}
                    </div>
                    <div
                        class="le-text-body2 px-9"
                        style="min-height:88px; font-size: 24px;"
                        v-html="$t('trialBadgeCampaign.dialogDone.body')"
                    ></div>
                    <div class="pa-9 d-flex justify-end gap-3">
                        <v-btn
                            color="#582915"
                            depressed
                            dark
                            style="height: 60px !important; min-width: 120px !important; font-size: 28px !important;"
                            :ripple="false"
                            @click="doneOpen = false"
                        >
                            {{ $t('trialBadgeCampaign.dialogDone.btnOk') }}
                        </v-btn>
                    </div>
                </v-card>
            </v-dialog>
        </div>
    </div>
</template>
  
<script>
import campaignIssueMixin from '@/views/campaigns/_shared/campaignIssueMixin';
  
export default {
    name: 'CustomCampaignTest',
    mixins: [campaignIssueMixin],

    data() {
        return {
            dbgLogs: [],
            lastAlertAt: 0, // 얼럿 중복 방지
            hasInteracted: false,
        };
    },

    mounted() {
        // ✅ 테스트용 자동 입력
        if (process.env.NODE_ENV !== 'production') {
            if (!this.name) this.name = '테스트';
            if (!this.email) this.email = 'test@example.com';
        }

        // if (!this.name) this.name = '테스트';
        // if (!this.email) this.email = 'test@example.com';
    },
  
    methods: {
        dbg(type) {
            const t = new Date().toISOString().split('T')[1].slice(0, 8);
            this.dbgLogs.unshift(`${t} : ${type}`);
            if (this.dbgLogs.length > 30) this.dbgLogs.pop();
        },
        
        tap(actionKey) {
            const now = Date.now();

            if (this.lastTapKey === actionKey && (now - this.lastTapAt) < 500) return;

            this.lastTapAt = now;
            this.lastTapKey = actionKey;

            if (actionKey === 'doneOk') { this.doneOpen = false; return; }
            if (actionKey === 'showConfirm') { this.showConfirm(); return; }
            if (actionKey === 'closeConfirm') { this.confirmOpen = false; return; }
            if (actionKey === 'submit') { this.submit(); return; }
        },

        testAction(e) {
            // 어떤 이벤트로 들어왔는지 기록
            this.dbg(`TEST ${e?.type || 'unknown'}`);

            // 일부 환경에서 같은 터치로 이벤트가 2번 들어오는 것 방지
            const now = Date.now();
            if (now - this.lastAlertAt < 700) return;
            this.lastAlertAt = now;

            alert('TEST 버튼 동작!');
        },

        dbgEvent(label, e) {
            const t = new Date().toISOString().split('T')[1].slice(0, 8);
            const type = e?.type || 'unknown';
            const pt = (e?.pointerType) ? ` pointerType=${e.pointerType}` : '';
            const touches = (e?.touches) ? ` touches=${e.touches.length}` : '';
            const changed = (e?.changedTouches) ? ` changed=${e.changedTouches.length}` : '';

            this.dbgLogs.unshift(`${t} : ${label} | event=${type}${pt}${touches}${changed}`);
            if (this.dbgLogs.length > 60) this.dbgLogs.pop();

            // 콘솔도 같이 (스탠바이미에서 개발자도구 가능하면 확인용)
            // eslint-disable-next-line no-console
            console.log(`[DBG] ${label}`, e);
        },

        onNoClick(e) {
            this.dbgEvent('NO CLICK HANDLER', e);

            // “눌렀다”가 확실히 보이도록: 필요하면 주석 해제
            // alert('NO 클릭 핸들러 들어옴');

            this.confirmOpen = false;
        },

        showConfirm() {
            if (!this.$refs.form?.validate()) return;

            this.confirmOpen = true;

            // 모달이 DOM에 붙고 transition이 안정화된 뒤부터 클릭 허용
            this.noReady = false;
            this.$nextTick(() => {
                setTimeout(() => { this.noReady = true; }, 150);
            });
        }

    },

    // computed: {
    //     bgStyle() {
    //         const bg = require('@/assets/img/campaigns/2026edukorea/bg.png');
    //         return {
    //             backgroundImage: `url(${bg})`,
    //             backgroundSize: 'cover',
    //             backgroundPosition: 'center',
    //             backgroundRepeat: 'no-repeat',
    //             minHeight: '100vh',
    //         };
    //     },
    // },
};
</script>

<style scoped>
    .sub-page-wrap {
        background-color: #fff4e3;
        min-height: 100vh;
        height: 100%;
    }

    .sub-page {
        background: url('~@/assets/img/campaigns/2026edukorea/bg.png') no-repeat top center;
        background-size: cover;
        max-width: 1080px;
        min-height: 1650px;
        max-height: calc(100vh - 50px);
        /* min-height: 1920px; */
        margin: 0 auto;
    }

    .form {
        margin-top: 863px;
        position: relative;
        z-index: 10;

        .contact_title {
            font-size: 32px;
        }
    }

    .badge-link {
        width: 350px;
        height: 350px;
        position: absolute;
        top: 360px;
    }

    @media (hover: none) and (pointer: coarse) {
        .v-btn:hover::before {
            opacity: 0 !important;
        }
        .v-btn:hover {
            filter: none !important;
        }
    }

    .sub-page, .form, .v-btn {
        touch-action: manipulation;
    }

    :deep(.v-text-field--outlined > .v-input__control > .v-input__slot) {
        min-height: 64px !important;
        padding: 0 20px !important;
    }

    :deep(.v-input input) {
        font-size: 24px;
    }

    :deep(.v-messages__message) {
        font-size: 20px !important;
        line-height: 20px !important;
    }
</style>